module.exports = __webpack_public_path__ + "static/img/guss.150bebf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guss.jpg
// module id = R6Rl
// module chunks = 1